import {
  createThemeSelector,
  createVariableThemeSelectorCreator
} from './utils'

export const spacingSelector = createThemeSelector(theme => theme.spacing)

export const getSpacingSelector = createVariableThemeSelectorCreator(
  // selector creator
  (multiplier = 1) =>
    createThemeSelector(spacingSelector, spacing => spacing(multiplier)),
  // generate cache key (must account for default value)
  (multiplier = 1) => multiplier
)
